import React from 'react'
import cn from 'classnames'

import './FormHelp.less'

type FormHelpProps = {
  className?: string
  children?: React.ReactNode
}

function FormHelp({ className, children }: FormHelpProps) {
  return (
    <span className={cn('form-help', className)}>
      {children}
    </span>
  )
}

export default FormHelp
